import { Clock } from 'lucide-react';

interface TimezoneToggleProps {
  useUTC: boolean;
  onChange: (useUTC: boolean) => void;
}

export function TimezoneToggle({ useUTC, onChange }: TimezoneToggleProps) {
  return (
    <button
      onClick={() => onChange(!useUTC)}
      className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium bg-bg-elevated border border-border text-text-muted hover:text-text hover:border-border-hover transition-colors"
      title={useUTC ? 'Switch to local time' : 'Switch to UTC'}
    >
      <Clock className="w-3.5 h-3.5" />
      <span>{useUTC ? 'UTC' : 'Local'}</span>
    </button>
  );
}
